<template>
  <div class="subsector nitricadipicacid">
    <div class="parent-sector">
      <p>Industrial Processes</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6">
          <h1>Nitric and Adipic Acid Production</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                Nitric acid is an inorganic compound used primarily to make
                synthetic commercial fertilizer. Adipic acid is a white
                crystalline solid used as a feedstock in the manufacture of
                synthetic fibers, coatings, plastics, urethane foams,
                elastomers, and synthetic lubricants. The production of these
                acids results in N₂O emissions as a by-product.
              </p>
              <p>
                Emissions from nitric acid production are estimated to increase
                by 17% between 2015 and 2030, which aligns with the estimated
                16% growth of nitric acid production. The global emission
                reduction potential in the nitric and adipic acid production
                source category is 231 MtCO₂e in 2030, or 86% of projected
                baseline emissions from nitric and adipic acid production.
                Roughly 80% of the abatement potential is achievable at
                break-even prices between $0 and $20, demonstrating that low
                breakeven prices can have a substantial impact on reducing
                emissions from this source category.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartNitric1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartNitric2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartNitric1 from "@/components/industrialprocesses/ChartNitric1";
import ChartNitric2 from "@/components/industrialprocesses/ChartNitric2";

export default {
  components: {
    ChartNitric1,
    ChartNitric2
  },
  data() {
    return {
      currentComp: "ChartNitric1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-lightblue-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}
.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #012e51;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}

.center button {
  position: static !important;
}
</style>
